import { CheckBadgeIcon } from "@heroicons/react/24/outline";

export const serviceAgreementIntervals = [
  { id: 4, name: "interval_id", value: 4, label: "Monthly" },
  {
    id: 1,
    name: "interval_id",
    value: 1,
    label: "Yearly (12 months)",
    icon: CheckBadgeIcon,
  },
  {
    id: 2,
    name: "interval_id",
    value: 2,
    label: "Half Yearly (6 months)",
    icon: CheckBadgeIcon,
  },
  {
    id: 3,
    name: "interval_id",
    value: 3,
    label: "Quarterly (3 months)",
    icon: CheckBadgeIcon,
  },
  {
    id: 9,
    name: "interval_id",
    value: 9,
    label: "Every 8 Months",
    icon: CheckBadgeIcon,
  },
  {
    id: 10,
    name: "interval_id",
    value: 10,
    label: "Every 10 Months",
    icon: CheckBadgeIcon,
  },
  {
    id: 5,
    name: "interval_id",
    value: 5,
    label: "Every 2 Years",
    icon: CheckBadgeIcon,
  },
  {
    id: 7,
    name: "interval_id",
    value: 7,
    label: "Every 3 Years",
    icon: CheckBadgeIcon,
  },
  {
    id: 8,
    name: "interval_id",
    value: 8,
    label: "Every 4 Years",
    icon: CheckBadgeIcon,
  },
  {
    id: 6,
    name: "interval_id",
    value: 6,
    label: "Every 5 Years",
    icon: CheckBadgeIcon,
  },
];

